import axios from "axios";

var axios2 = axios;

axios2.defaults.baseURL = "";
axios2.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.resolve(error);
  }
);

const requestGenericWithoutToken = {
  get: (url) => axios2.get(url),
  post: (url, body) => axios2.post(url, body),
  put: (url, body) => axios2.put(url, body),
  delete: (url) => axios2.delete(url),
};

export default requestGenericWithoutToken;
